import React from "react";

const TableDataNotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: "14px",
        color: "grey",
      }}
    >
      <h2>No data found</h2>
    </div>
  );
};

export default TableDataNotFound;
